var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "jss16660 jss16662",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0109 19.8221L18.4909 16.3021C19.7509 14.7321 20.4309 12.7821 20.4309 10.7721C20.4309 5.88211 16.4609 1.91211 11.5709 1.91211C6.68094 1.91211 2.71094 5.88211 2.71094 10.7721C2.71094 15.6621 6.68094 19.6321 11.5709 19.6321C13.5809 19.6321 15.5309 18.9521 17.1009 17.6921L20.6209 21.2121C21.0009 21.5921 21.6309 21.5921 22.0109 21.2121C22.3909 20.8321 22.3909 20.2121 22.0109 19.8221ZM14.5209 11.7621H12.5509V13.7321C12.5509 14.2721 12.1109 14.7121 11.5709 14.7121C11.0309 14.7121 10.5909 14.2721 10.5909 13.7321V11.7621H8.62094C8.08094 11.7621 7.64094 11.3221 7.64094 10.7821C7.64094 10.2421 8.08094 9.80211 8.62094 9.80211H10.5909V7.83211C10.5909 7.29211 11.0309 6.8521 11.5709 6.8521C12.1109 6.8521 12.5509 7.29211 12.5509 7.83211V9.80211H14.5209C15.0609 9.80211 15.5009 10.2421 15.5009 10.7821C15.5009 11.3221 15.0609 11.7621 14.5209 11.7621Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoomIn.9270c8cd1decc56ecd6e29347bdb0e55.svg";
export { ForwardRef as ReactComponent };